import React, { useEffect, useState } from 'react'
import { NavBar } from '../../../components/NavBar/NavBar'
import {
  PageWrapper,
  Flex,
  GridItem,
  GridWrapper,
  Separator,
  ItemsGrid,
  H1WithBack,
} from '../../../styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { useNavigate, useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import RemoveCircle from '../../../assets/icons/RemoveCircle'
import { AppDispatch, RootState } from 'store'
import {
  clearInventoryCategory,
  getSingleInventoryCategory,
  updateInventoryCategory,
} from 'features/inventory/invSettingsCategoriesSlice'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { convertToInvCategoriesModalData } from './InventoryCategories'
import { TitleText } from 'styling/Typography'
import { TextDisplayCard } from 'components/TextDisplayCard/TextDisplayCard'
import { costingMethodOptions, trackingModeOptions } from '../Items/itemsData'
import { InventoryCategoryModal } from './InventoryCategoryModal'

export const SingleInventorySubcategory = () => {
  const { singleInventoryCategory } = useSelector(
    (state: RootState) => state.inventoryCategories,
  )
  const [fields, setFields] = useState(singleInventoryCategory?.fields) // TODO refactor
  const dispatch = useDispatch<AppDispatch>()
  const { subId } = useParams()
  const [modal, setModal] = useState({ open: false, value: null })
  const navigate = useNavigate()

  useEffect(() => {
    dispatch(getSingleInventoryCategory(subId))
    return () => {
      dispatch(clearInventoryCategory())
    }
  }, [])

  useEffect(() => {
    singleInventoryCategory ? setFields(singleInventoryCategory.fields) : null
  }, [singleInventoryCategory])

  const handleRemove = (itemId: number) => {
    const modified = fields.filter((item) => item.field.id !== itemId)
    const array = modified.map((item) => item.field.id)
    setFields(modified)
    dispatch(updateInventoryCategory({ category: convertToInvCategoriesModalData(singleInventoryCategory), fields: array }))
  }

  return (
    <>
      <NavBar />
      <PageWrapper>
        <Flex between>
          <H1WithBack arrow title={singleInventoryCategory?.name} />
          <Flex gap='1rem' center >
            <Button variant='secondary' onClick={() => setModal({ open: true, value: convertToInvCategoriesModalData(singleInventoryCategory) })}>
              Edit
            </Button>
            <Button variant='primary' onClick={() => navigate('fields')}>
              Edit Fields
            </Button>
          </Flex>
        </Flex>
        <Separator />
        <ItemsGrid columns={3} mb='1rem' >
          <TextDisplayCard labelText='Name' title={singleInventoryCategory?.name} />
          <TextDisplayCard labelText='Default tracking mode' title={trackingModeOptions.find(t => t.value == singleInventoryCategory?.defaultTrackingMode)?.label} />
          <TextDisplayCard labelText='Default costing method' title={costingMethodOptions.find(t => t.value == singleInventoryCategory?.defaultCostingMethod)?.label} />
          <TextDisplayCard labelText='Parent category' title={singleInventoryCategory?.parent?.name || '/'} />
        </ItemsGrid>
        <TitleText weight='bold' >Fields:</TitleText>
        <GridWrapper>
          <ItemsGrid columns={3}>
            {fields?.length ? (
              fields?.map((item) => {
                return (
                  <GridItem key={item.id}>
                    {item.field.label}
                    <Flex center justcenter onClick={() => handleRemove(item.field.id)}>
                      <RemoveCircle />
                    </Flex>
                  </GridItem>
                )
              })
            ) : (
              <NoItems title='Fields' />
            )}
          </ItemsGrid>
        </GridWrapper>
        {modal.open && (
          <InventoryCategoryModal subcategory={true} value={modal.value} closeModal={() => setModal({ open: false, value: null })} />
        )}
      </PageWrapper>
    </>
  )
}
